<template>
  <div class="col-6 text-end" v-if="visible">
    <div class="popup_bg"></div>
    <div id="myModal" class="modal_class">
      <div class="modal-content invoice">
        <div class="d-flex justify-content-between">
          <span>Deactivation Logs</span>
          <span @click="$emit('close')" class="close">&times;</span>
        </div>

        <div
          class="hover-popup my-3"
          style="height: 500px; overflow-y: auto; scrollbar-width: thin"
        >
          <div class="popup-content">
            <div
              class="active_services mt-2"
              v-if="rtlEponData && Object.keys(rtlEponData).length"
            >
              <div v-for="item in rtlEponData?.upldown_logs" :key="item">
                <div class="d-flex align-items-center">
                  <div
                    class="rounded"
                    style="
                      height: 50px;
                      width: 50px;
                      background-color: dimgrey;
                    "
                  ></div>
                  <div class="p-2">
                    <p class="m-0 text-left">{{ item.status }}</p>
                    <p
                      class="m-0 text-left"
                      style="font-size: 14px; color: greenyellow !important"
                    >
                      • Date ({{ item.date }})
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="active_services mt-2"
              v-if="rtlData && Object.keys(rtlData).length"
            >
              <div v-for="item in rtlData?.Deactivation_Logs" :key="item">
                <div class="d-flex align-items-center">
                  <div
                    class="rounded"
                    style="
                      height: 50px;
                      width: 50px;
                      background-color: dimgrey;
                    "
                  ></div>
                  <div class="p-2">
                    <p class="m-0 text-left">{{ item.Deactive_Reason }}</p>
                    <p
                      class="m-0 text-left"
                      style="font-size: 14px; color: greenyellow !important"
                    >
                      • Active Time ({{ item.Active_Time }})
                    </p>
                    <p
                      class="m-0 text-left"
                      style="font-size: 14px; color: red !important"
                    >
                      • Deactive Time ({{ item.Deactive_Time }})
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogsPopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rtlData: {
      type: Object,
      default: () => ({}),
    },
    rtlEponData: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

